// import * as types from '../../store/mutation-types'
// const VehicleLocalStorageKey = 'uniq-vehicles-items'

import VehicleService from './VehicleService'
import VehicleRoutes from './route-types'
import StoreUtil from '@/store/utils'
import DeepDiff from 'deep-diff'

// const vehicles = localStorage.getItem(VehicleLocalStorageKey)
// if (vehicles && vehicles !== 'undefined') {
//   state.items = JSON.parse(vehicles)
// }

const tag = 'vehicle'

const state = {
  // items: [],
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: []
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: state => state.snapshots,
  baseSnapshot: state => state.snapshots[state.baseIndex],
  currentSnapshot: state => state.snapshots[state.currentIndex],
  snapshotDiff: state => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  }
}

const actions = {
  async getStoreItem({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await VehicleService.getEntity(id, ''))
    StoreUtil.setStorage(entity.id, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  async editStoreItem({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await VehicleService.getEntity(id, ''))
    StoreUtil.setStorage(entity.id, tag, entity)
    commit('saveInitialSnapshots', entity)
    StoreUtil.routeToDetail(VehicleRoutes.VehicleListView.path, entity.id, false)
  },
  async addStoreItem({ commit }, payload) {
    const entity = await VehicleService.getNewEntity()
    if (payload && payload.rego) {
      entity.rego = payload.rego
    }
    StoreUtil.setStorage(entity.id, tag, entity)
    commit('saveInitialSnapshots', entity)
    StoreUtil.routeToDetail(VehicleRoutes.VehicleListView.path, entity.id, true, payload)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setCustomer({ commit, state }, updateModel) {
    commit('setCustomer', updateModel)
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setCustomer(state, updateModel) {
    state.snapshots[state.currentIndex].customer = updateModel.customer
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
